export const dcrFieldValueStyles = {
	multiLineValue: {
		display: 'flex',
		flexDirection: 'column',
		gap: 0.5,
		py: 0.5
	}
};
